import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import {additionalDataForCreateIntegration, dialogs, hideAddIntegrationDialog, loadings} from "../../../../store/slice";
import {
    GWORKSPACE_ENDPOINT_MAPPING_NAME,
    initialVendorForm,
    PATH_INTEGRATIONS_ADDED_EXACT
} from "../../../../constants";
import {useForm} from "../../../../../../../newShared/hooks/useForm";
import React, {useEffect, useState} from "react";
import {validateEmail} from "../../../../../../../newShared/utils/text";
import {AddIntegration} from "../../../../store/actions";
import {useMessageDialog} from "../../../../../../barsEnvironment/MessageDialog/hooks/useMessageDialog";
import {
    UseManageWorkspacesAndOrganizations
} from "../../../../../../authWorkspacesCookies/cookies/hooks/useManageWorkspacesAndOrganizations";
import {addAppVendorManage, GworkspaceIntergationDetailsType} from "../../../../types";
import {addErrorSnack} from "../../../../../../barsEnvironment/snack/store/slice";
import {useMainTranslation} from "../../../../../../../newShared/hooks/useMainTranslationHooks/useMainTranslation";
import {useSelectVendorInIntegration} from "../../../useSelectVendorInIntegration";

export const useAddIntegrationGworkspaceDialog = () => {
    //root
    const dispatch = useDispatch();
    const history = useHistory();
    const {workspaceId} = UseManageWorkspacesAndOrganizations();
    const {setMessage} = useMessageDialog();
    //selectors
    //TODO on init -> get available apps -> find detailsId by endpointMappingName -> put in form
    const {addDialogs} = useSelector(dialogs);
    const {addIntegration, vendorsAndEmployeesForCreate} = useSelector(loadings);
    const isOpen = addDialogs[GWORKSPACE_ENDPOINT_MAPPING_NAME].isOpen;
    const additionalDataForCreate = useSelector(additionalDataForCreateIntegration);
    //actions
    const handleClose = () => {
        dispatch(hideAddIntegrationDialog(GWORKSPACE_ENDPOINT_MAPPING_NAME));
    };

    const handleSubmit = () => {
        const detailsId = addDialogs[GWORKSPACE_ENDPOINT_MAPPING_NAME].app?.id;
        if (!detailsId) return;
        if(tab === 'selectVendor' && detailsId){
            vendorForm.form.selectedVendor && dispatch(AddIntegration({
                integrationDetails: {...form, detailsId},
                createVendor: null,
                vendorId: vendorForm.form.selectedVendor.id,
                onSuccess
            }));
        }else{
            //createVendor
            if(vendorForm.form.create.type && vendorForm.form.create.riskLevel && vendorForm.form.create.providedService){
                dispatch(AddIntegration({
                    integrationDetails: {...form, detailsId},
                    createVendor: {
                        owner: vendorForm.form.create.owner?.publicId ? {
                            id: vendorForm.form.create.owner?.publicId,
                            name: '',
                        } : null,
                        riskLevel: vendorForm.form.create.riskLevel,
                        providedService: vendorForm.form.create.providedService,
                        type: vendorForm.form.create.type,
                    },
                    vendorId: null,
                    onSuccess
                }));
            }
        }
    }

    const {t} = useMainTranslation('', {keyPrefix: 'pathIntegrations.AvailableAppsList.dialogs'});

    const onSuccess = (id: string) => {
        setMessage({title: t('Completed successfully!'), message: t(`Integration created! The integration is in 'In progress' status. Wait for completion.`)});
        handleClose();
        history.push(PATH_INTEGRATIONS_ADDED_EXACT.replace(':id', id));
    }

    //useEffects
    useEffect(() => {
        if(!isOpen) cleanUp();
        //eslint-disable-next-line
    }, [isOpen])

    //form
    const initialForm: GworkspaceIntergationDetailsType = {
        applicationId: '',
        workspaceId: workspaceId ?? '',
        status: '',
        integration: {
            credentials: '',
            adminEmail: '',
        },
        identity: false,
        hris: false,
        endpointMappingName: GWORKSPACE_ENDPOINT_MAPPING_NAME,
        detailsId: '',
        //additional:
        name: '',
    };

    const [fileName, setFileName] = useState<String>("");
    const {form, setForm, handleChange} = useForm<GworkspaceIntergationDetailsType>(initialForm);
    const handleChangeIntegration = (e: React.ChangeEvent<HTMLInputElement>) => {
        setForm(prev => ({...prev, integration: {...prev.integration, [e.target.name]: e.target.value}}));
    }

    //other
    const checkIfJsonHasAllKeys = (obj: any) => {
        return ("auth_provider_x509_cert_url" in obj &&
            "auth_uri" in obj &&
            "client_email" in obj &&
            "client_id" in obj &&
            "client_x509_cert_url" in obj &&
            "private_key" in obj &&
            "private_key_id" in obj &&
            "project_id" in obj &&
            "token_uri" in obj &&
            "type" in obj);
    }

    const checkIfJsonAllValuesExists = (obj: any) => {
        return (
            obj.auth_uri?.trim().length > 0 &&
            obj.client_email?.trim().length > 0 &&
            obj.client_id?.trim().length > 0 &&
            obj.client_x509_cert_url?.trim().length > 0 &&
            obj.private_key?.trim().length > 0 &&
            obj.private_key_id?.trim().length > 0 &&
            obj.project_id?.trim().length > 0 &&
            obj.token_uri?.trim().length > 0 &&
            obj.type?.trim().length > 0
        )
    }

    const onChangeFileInput = (e: any) => {
        const fileReader = new FileReader();
        const prevFileName = fileName;
        if(e!.currentTarget.files){
            try{
                fileReader.readAsText(e!.currentTarget?.files[0], "UTF-8");
                setFileName(e!.currentTarget.files[0].name || "");
            }catch (ex){
                return;
            }
        }else{
            return;
        }
        fileReader.onload = (onLoad) => {
            // console.log('file: ', onLoad?.target?.result);
            const json = onLoad?.target?.result as string;
            // console.log(`JOSN: ${json}`);
            if(json.length){
                const obj = JSON.parse(json);
                // console.log(`CHEKS: ${checkIfJsonHasAllKeys(obj)} - - - ${checkIfJsonAllValuesExists(obj)}`);
                if(checkIfJsonHasAllKeys(obj) && checkIfJsonAllValuesExists(obj)){
                    setForm({...form, integration: {...form.integration, credentials: json}});
                }else{
                    dispatch(addErrorSnack(t('File is not valid!')));
                    setFileName(prevFileName);
                }
            }
        };
    }

    //
    const ref = React.createRef<HTMLInputElement>();
    const filePicker = () => {
        ref.current && ref.current.click();
    };

    const cleanUp = () => {
        setForm(initialForm);
        setFileName('');
        setStep('app');
        vendorForm.setForm(initialVendorForm);
        setTab('selectVendor');
    }

    //stepper
    const [step, setStep] = useState<'app' | 'vendor'>('app');
    const [tab, setTab] = useState<'selectVendor' | 'createVendor'>('selectVendor');

    const vendorForm = useForm<addAppVendorManage>(initialVendorForm);

    const {
        handleSetOwner, handleSetProvidedService, handleSetRiskLevel, handleSetType, handleSetVendor
    } = useSelectVendorInIntegration(vendorForm.form, vendorForm.setForm);

    return{
        isOpen,
        app: addDialogs[GWORKSPACE_ENDPOINT_MAPPING_NAME].app,
        handleClose,
        isLoading: addIntegration,
        isOk: form.integration.credentials.length > 0 && form.name.trim().length > 0 && validateEmail(form.integration.adminEmail),
        isOkVendorsStep: () => {
            if(tab === 'createVendor'){
                return (vendorForm.form.create.riskLevel ?? '').length > 0 && (vendorForm.form.create.type ?? '').length > 0
                    && (vendorForm.form.create.providedService ?? '').length > 0
            }else if(tab === 'selectVendor'){
                return vendorForm.form.selectedVendor !== null;
            }
        },
        actions: {
            handleClose,
            handleSubmit,
            onChangeFileInput,
            handleChange,
            handleChangeIntegration,
            filePicker
        },
        ref,
        form,
        fileName,
        stepper: {
            step,
            setStep,
            tab,
            setTab,
            form: vendorForm.form,
            handleSetOwner,
            handleSetProvidedService,
            handleSetRiskLevel,
            handleSetType,
            handleSetVendor,
            additionalDataForCreate,
            isLoadingAdditionalData: vendorsAndEmployeesForCreate,
        }
    }
}
